import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "reshine_session_token";
// Auth design: the httpOnly + Secure + SameSite=None session cookie is the primary credential.
// This localStorage Bearer token is only a fallback for browsers/embedded contexts that block
// third-party cookies (without it, users were silently logged out). Sessions are long-lived (90 days)
// with server-side sliding renewal on each authenticated request, so active users stay logged in.
// It is cleared on 401/logout. The New Job draft (non-sensitive form data) is also kept in
// localStorage deliberately so it survives tab closure.

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) clearToken();
    return Promise.reject(err);
  }
);

export default api;
